import { IBuildersProjectsData } from '../../types/buildersProjects';

/**
 * Возвращает данные аналитики для поля `products`.
 */
export const getAnalyticsProducts = (buildersProjects?: IBuildersProjectsData) => {
  if (buildersProjects) {
    return buildersProjects.projectsList.map(({ id, name, company }, index) => ({
      id,
      extra: { name, parentId: company.id },
      offerType: 'CountryBuilderProject',
      position: index + 1,
    }));
  }

  return [];
};
